import React from "react";
import { useLocation, NavLink } from "react-router-dom";

import { Nav } from "react-bootstrap";
import { useUser } from '../../contexts/UserContext';

import logo from "assets/img/reactlogo.png";

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  const { user } = useUser();

  const layout = location.pathname.startsWith('/admin') ? '/admin' : '/manage';

  const handleClick = () => {
    // Reset filters in localStorage (pagination/filter state — non-sensitive)
    window.localStorage.removeItem('filters');
    localStorage.removeItem('currentPage');
  }

  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            href="#"
            className="simple-text logo-mini mx-1"
          >
            <div className="logo-img">
              <h6 style={{position:"absolute", top:"0px", right:"5px"}}>{user?.organization_name || ''}</h6>
              <img src={require("assets/img/SONICmedia.png")} alt="..." />
            </div>
          </a>
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if (!prop.redirect && !prop.hidden)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                    onClick={handleClick}
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
          <li className={"active-pro " + activeRoute(layout + '/change-password')}>
            <NavLink
              to={layout + '/change-password'}
              className="nav-link"
              activeClassName="active"
            >
              <i className="nc-icon nc-circle-09" />
              <p>{user?.first_name} {user?.last_name}</p>
            </NavLink>
          </li>
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
